import { mdiFacebook, mdiTwitter, mdiYoutube } from '@mdi/js'

export default {
  namespaced: true,
  state: () => ({
    helps: [
      {
        text: 'Quiero comprar',
        link: process.env.VUE_APP_LINK_QUIERO_COMPRAR
      },
      {
        text: 'Soporte técnico',
        link: process.env.VUE_APP_LINK_SOPORTE_TECNICO
      },
      {
        text: 'Tutorial del usuario',
        link: process.env.VUE_APP_LINK_TUTORIAL_USUARIO
      },
      {
        text: 'Manual del usuario',
        link: process.env.VUE_APP_LINK_MANUAL_USUARIO
      }
    ],
    socials: [
      {
        icon: mdiFacebook,
        color: 'indigo',
        link: process.env.VUE_APP_LINK_FACEBOOK
      },
      {
        icon: mdiTwitter,
        color: 'blue',
        link: process.env.VUE_APP_LINK_TWITTER
      },
      {
        icon: mdiYoutube,
        color: 'red lighten-3',
        link: process.env.VUE_APP_LINK_YOUTUBE
      }
    ]
  }),
  getters: {
    helps(state) {
      return state.helps
    },
    socials(state) {
      return state.socials
    }
  }
}
